import { useChannels } from '@/hooks/api/useChannels';
import { Link } from 'react-router-dom';
import { SpriteSvg } from '@/components/common/SpriteSvg';
import { useAdBanners } from '@/hooks/api/useAdBanners';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';

export const Menu = () => {
  const { data: channels } = useChannels();
  const { data: ad_banners } = useAdBanners();

  return (
    <>
      <input type="checkbox" className="opener-checkbox" id="menu-opener" />
      <nav>
        <label className="backdrop" htmlFor="menu-opener"></label>
        <div className="container">
          <div className="header">
            <label htmlFor="menu-opener">
              <SpriteSvg name={'icon-menu-close'} className={'i'} />
            </label>
          </div>
          <div className="body">
            <div className="menu-wrapper channels">
              <div className="title">
                <SpriteSvg name={'icon-creator'} className={'i'} />
                Channel
              </div>
              {channels?.map((c) => (
                <Link key={`menu_${c.id}`} to={`/channels/${c.cid}`}>
                  <img src={c.icon_url} className="icon" />
                  <span>{c.name}</span>
                </Link>
              ))}
            </div>
            <div className="menu-wrapper">
              <div className="title">
                <SpriteSvg name={'icon-flag'} className={'i'} />
                関連サイト
              </div>
              <a href="https://www.cityheaven.net/">シティヘブンネット</a>
            </div>
            <div className="menu-wrapper">
              <div className="title">
                <SpriteSvg name={'icon-other'} className={'i'} />
                その他
              </div>
              <a href="https://www.cityheaven.net/tokyo/sitepolicy/" className="sm">
                プライバシーポリシー
              </a>
              <a href="https://www.cityheaven.net/tokyo/ACUserToiawase/" className="sm">
                お問い合わせ
              </a>
            </div>
            {isDesktop && (
              <div className="menu-wrapper">
                {ad_banners
                  ?.filter((ad_banner) => ad_banner.display_target === 'pc')
                  .map((ad_banner) => {
                    const gtmClickValue = `ad_banner_click:${ad_banner.id}`;
                    const gtmDisplayValue = `ad_banner_display:${ad_banner.id}`;
                    return (
                      <Link
                        key={`ab-${ad_banner.id}`}
                        to={ad_banner.url}
                        className="banner ad-banner"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-ad-banner-click={gtmClickValue}
                        data-ad-banner-display={gtmDisplayValue}
                      >
                        <img src={ad_banner.content_url} data-ad-banner-click={gtmClickValue} />
                      </Link>
                    );
                  })}
              </div>
            )}
            <div className="copyright">
              &copy;CityHeaven.net
              <br />
              Powered by{' '}
              <a href="https://knip.jp" className="copyright">
                KNIP
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
